module.exports = __webpack_public_path__ + "static/media/notice.88c7d493.svg";